module.exports = __webpack_public_path__ + "img/cx_teste_perfil_lipidico.cc15c862.webp";